<template>
  <tbody class="cm-table-state-block">
    <td :colspan="colspan">
      <Spinner position="relative" v-if="isLoading" />
      <ErrorBlock v-else-if="isError" />
      <NotFound :description="notFoundText" v-else-if="isEmpty" />
    </td>
  </tbody>
</template>

<script>
import Spinner from "@/manzana_library/components/Widgets/Spinner.vue";
import NotFound from "@/manzana_library/components/Elements/NotFound.vue";
import ErrorBlock from "@/manzana_library/components/Elements/ErrorBlock.vue";

export default {
  name: "CmTableStateBlock",

  components: {
    Spinner,
    ErrorBlock,
    NotFound
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean,
      default: false
    },
    isEmpty: {
      type: Boolean,
      default: false
    },
    colspan: {
      type: Number,
      default: 1
    },
    notFoundText: {
      type: String,
      default: ""
    }
  }
}
</script>

<style lang="scss">
.cm-table-state-block {
  width: 100%;
  height: 100%;
  .spinner{
    margin: 20px auto !important;
  }
  .cm-not-found,
  .cm-error-block {
    border: none;
    &__title {
      font-size: 22px;
    }
  }
}
</style>
